import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    const retryable = cfg && (cfg.url?.startsWith("/admin") || cfg.url === "/auth/me" || cfg.url === "/auth/change-password");
    if (error.response?.status === 401 && retryable && !cfg._retry) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function errorMessage(err, t) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") {
    const k = `errors.${d}`;
    const tr = t(k);
    return tr !== k ? tr : d;
  }
  if (Array.isArray(d)) return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return t("errors.generic");
}

export const thumbUrl = (id) => `${API}/uploads/${id}/thumb`;
export const INSTAGRAM_URL = "https://www.instagram.com/mcillusionsprints";
